module.exports = __webpack_public_path__ + "static/media/dog-chow-chow.d71ef0be.png";